import './downloads.scss';

require('../../assets/images/light_wood.jpeg');
require('../../assets/images/dark_wood.jpeg');

/**
 * Controller für den Downloads-Bereich.
 *
 * Steuert das Ein-/Ausklappen zusätzlicher Download-Elemente, indem
 * relevante ARIA-Attribute gesetzt werden (aria-hidden an Items, aria-expanded am Button).
 *
 * Nutzung: new Downloads($root).initialize()
 */
class Downloads {
    /**
     * @param {HTMLElement} $element Wurzel-Element des Downloads-Blocks.
     */
    constructor ($element) {
        /** @type {HTMLElement} */
        this.$root = $element;
        /** @type {HTMLElement|null} */
        this.$button = this.$root.querySelector('.downloads__readmore-button');
        /** @type {NodeListOf<HTMLElement>} */
        this.$$items = this.$root.querySelectorAll('.downloads__item[aria-hidden]');
    }

    /**
     * Initialisiert das Verhalten: synchronisiert Anfangszustand und bindet Click-Handler.
     * Sicher mehrfach aufrufbar; pro Instanz wird ein Handler registriert.
     *
     * @returns {void}
     */
    initialize () {
        if (!this.$button || !this.$$items.length) return;
        this.setOpen(this.isOpen());
        this.$button.addEventListener('click', (e) => {
            e.preventDefault();
            this.toggle();
        }, { once: false });
    }

    /**
     * Ermittelt den aktuellen Offen-Status.
     * Bevorzugt aria-expanded am Button; fällt zurück auf das erste Item (aria-hidden).
     *
     * @returns {boolean}
     */
    isOpen () {
        const expanded = this.$button?.getAttribute('aria-expanded');
        if (expanded !== null) return expanded === 'true';
        const first = this.$$items[0];
        return first?.getAttribute('aria-hidden') === 'false';
    }

    /**
     * Setzt den Offen-Status und aktualisiert ARIA-Attribute.
     *
     * @param {boolean} open Gewünschter Status.
     * @returns {void}
     */
    setOpen (open) {
        this.$$items.forEach((el) => el.setAttribute('aria-hidden', open ? 'false' : 'true'));
        this.$button?.setAttribute('aria-expanded', String(open));
    }

    /**
     * Toggles zwischen offen/geschlossen.
     * @returns {void}
     */
    toggle () {
        this.setOpen(!this.isOpen());
    }
}

export { Downloads };

// Initialisiert alle Downloads-Blöcke bei custom content.loaded Event
window.addEventListener('content.loaded', (e) => {
    const { $context } = e.detail ?? {};
    if (!$context) return;

    const $$roots = $context.querySelectorAll('[data-downloads="root"]');
    if (!$$roots.length) return;

    $$roots.forEach((root) => {
        const $root = new Downloads(root);
        $root.initialize();
    });
});
